export default "__VITE_ASSET__lK_WbxPV__ 600w";